import styled from 'styled-components';

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .title {
    font-size: ${({ theme }) => theme.typography.sizes.h4}px;
    line-height: 120%;
    display: block;
  }

  .description {
    white-space: pre-line;
    font-size: ${({ theme }) => theme.typography.sizes.lg}px;
    line-height: ${({ theme }) => theme.typography.lineHeight.xl}px;
    font-weight: ${({ theme }) => theme.typography.weight.light};
  }
`;
